import { useEffect, useState } from "react";
import usePagination from "../../usePagination";
import { fetchUserGroups } from "../../../service/UserService/groupService";
import { message } from "antd";

export const useMyGroup = (search) => {
  const [groupData, setGroupData] = useState();
  const [loading, setLoading] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  const {
    currentPage,
    pageSize,
    setTotal,
    paginationConfig,
    handlePageChange,
    setCurrentPage,
  } = usePagination(0, 10);

  // ✅ debounce inside hook
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  const getGroupData = async () => {
    setLoading(true);

    const params = {
      page: currentPage,
      size: pageSize,
      search: debouncedSearch,
    };

    const response = await fetchUserGroups(params);

    if (response.success) {
      setGroupData(response?.data?.content || []);
      setTotal(response?.data?.totalElements || 0);
    } else {
      message.error(response.message);
    }

    setLoading(false);
  };

  useEffect(() => {
    getGroupData();
  }, [currentPage, pageSize, debouncedSearch]);

  useEffect(() => {
    setCurrentPage(0);
  }, [debouncedSearch]);

  return {
    groupData,
    loading,
    paginationConfig,
    handlePageChange,
  };
};